import { Link } from "react-router-dom";

const categories = [
  {
    title: "影视资讯",
    desc: "最新行业动态与热点新闻",
    icon: "ri-newspaper-line",
    to: "/category/资讯",
    accent: "bg-primary-100 text-primary-700",
  },
  {
    title: "电视剧",
    desc: "热播剧集与高分口碑剧",
    icon: "ri-tv-2-line",
    to: "/category/电视剧",
    accent: "bg-accent-100 text-accent-700",
  },
  {
    title: "电影",
    desc: "院线新片与经典佳作",
    icon: "ri-film-line",
    to: "/category/电影",
    accent: "bg-secondary-100 text-secondary-900",
  },
];

export default function QuickCategories() {
  return (
    <section className="w-full px-4 md:px-6 mt-10">
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
        {categories.map((cat, index) => (
          <Link
            key={cat.title}
            to={cat.to}
            className="group flex items-center gap-4 rounded-lg bg-background-100 p-4 ring-1 ring-background-200 transition-all hover:bg-white hover:ring-primary-200 cursor-pointer animate-fade-up md:p-5"
            style={{ animationDelay: `${index * 80}ms` }}
          >
            <span
              className={`flex h-14 w-14 shrink-0 items-center justify-center rounded-lg md:h-16 md:w-16 ${cat.accent}`}
            >
              <i className={`${cat.icon} text-2xl md:text-3xl`}></i>
            </span>
            <span className="min-w-0">
              <span className="block text-base font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors">
                {cat.title}
              </span>
              <span className="mt-1 block text-xs text-foreground-500 md:text-sm">
                {cat.desc}
              </span>
            </span>
            <span className="ml-auto flex h-8 w-8 items-center justify-center rounded-full text-foreground-400 group-hover:bg-primary-600 group-hover:text-background-50 transition-colors">
              <i className="ri-arrow-right-line"></i>
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}